export const appVersion = window.ENVS.VERSION || 'local';

export const ROOT_CACHE_STORAGE_NAME = `root__${appVersion}__requests-cache`;
export const USER_INFO_CACHE_KEY = 'personal_data';
